<!--
 * @Description: description
 * @Author: chenguobiao
 * @Date: 2021-08-17 17:08:43
 * @LastEditTime: 2021-08-30 14:59:14
 * @LastEditors: chenguobiao
-->
<template>
  <div class="wrap">
    <div ref="box" class="box">
      <div ref="marquee" class="marquee text">{{text}}</div>
      <div ref="copy" class="copy text"></div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Marquee',
  props: ['list'], // 父组件传入数据， 数组形式 [ "连雨不知春去","一晴方觉夏深"]
  data () {
    return {
      text: '', // 数组文字转化后的字符串
      timer: Object.freeze(null)
    }
  },
  watch: {
    list: {
      immediate: true,
      handler(list) {
        // 把父组件传入的arr转化成字符串
        for (let i = 0; i < list.length; i++) {
          this.text += ' ' + list[i]
        }
        this.$nextTick(() => {
          this.timer && clearInterval(this.timer)
          this.move()
        })
      }
    }
  },
  mounted() {
  },
  methods: {
    move () {
      // 获取文字text 的计算后宽度
      let width = this.$refs.marquee.getBoundingClientRect().width
      if (width === 0) return
      this.$refs.copy.innerText = this.text // 文字副本填充
      let distance = 0 // 位移距离
      // 设置位移
      this.timer = setInterval(() => {
        distance = distance - 1
        // 如果位移超过文字宽度，则回到起点
        if (-distance >= width) {
          distance = 16
        }
        this.$refs.box.style.transform = 'translateX(' + distance + 'px)'
      }, 20)
    }
  },
  destroyed() {
    clearInterval(this.timer)
  }
}
</script>
<style scoped>

.wrap {
  overflow: hidden;
}

.box {
  width: 80000%;
}

.box div {
  float: left;
}

.marquee {
   margin: 0 16px 0 0;
}
</style>
